import React from "react";
import { Button } from "react-bootstrap";
import moment from "moment";

const serverOnlySortComparator = () => 0;

const meetingDateFilterComparator = (filterLocalDate, cellValue) => {
  if (cellValue == null) return -1;
  const a = new Date(filterLocalDate);
  a.setHours(0, 0, 0, 0);
  const b = new Date(cellValue);
  b.setHours(0, 0, 0, 0);
  const filterBy = a.getTime();
  const filterMe = b.getTime();
  if (filterBy === filterMe) return 0;
  if (filterMe < filterBy) return -1;
  return 1;
};

/**
 * AG Grid column definitions for one status section.
 *
 * With the Infinite Row Model, placeholder rows exist before data loads
 * (`params.data` is undefined). Every callback and renderer guards against this.
 */
export function buildMeetingColumnDefs({
  currentStatus,
  statusType,
  status,
  setDetailsOpen,
  setRole,
  setUserID,
  handleChangestatus,
  viewComment,
  viewDocument,
  view,
  openModal,
  asssonpossible,
  UpdateDetails,
  meetinglog,
  handleGeneratePartnersXmlReport,
}) {
  return [
    {
      checkboxSelection: (params) => {
        if (!params?.data) return false;
        return params.data.currentStatus === statusType || !params.data.currentStatus;
      },
      field: "Meeting Id",
      headerClass: !(currentStatus === statusType || !currentStatus)
        ? "disabled-checkbox-cell"
        : "",
      cellClassRules: {
        "disabled-checkbox-cell": () =>
          !(currentStatus === statusType || !currentStatus),
      },
      minWidth: window.innerWidth < 991 ? 230 : 110,
      sortable: false,
      filter: "agTextColumnFilter",
    },
    {
      field: "Schedule Date",
      sortable: true,
      comparator: serverOnlySortComparator,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: meetingDateFilterComparator,
        inRangeInclusive: true,
      },
      valueFormatter: (params) => {
        return params.value
          ? moment(params.value).format("DD-MM-YYYY h:mm:ss a")
          : "";
      },
    },
    {
      field: "Created Date",
      refreshValuesOnOpen: true,
      sort: "desc",
      sortable: true,
      comparator: serverOnlySortComparator,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: meetingDateFilterComparator,
        inRangeInclusive: true,
      },
      valueFormatter: (params) => {
        return params.value
          ? moment(params.value).format("DD-MM-YYYY h:mm:ss a")
          : "";
      },
    },
    {
      field: "Client Name",
      sortable: false,
      onCellClicked(params) {
        if (!params?.data?.data) return;
        setDetailsOpen(true);
        setRole("client");
        setUserID(params.data.data.clientData?._id);
      },
    },
    {
      field: "Physician Name",
      sortable: false,
      onCellClicked(params) {
        if (!params?.data?.data) return;
        const record = params.data.data;
        setDetailsOpen(
          record.doctorData?._id || record.offerDates?.[0]?.DoctorId
            ? true
            : false
        );
        setRole("doctor");
        setUserID(
          record.doctorData
            ? record.doctorData._id
            : record.offerDates?.[0]
              ? record.offerDates[0]?.DoctorId
              : null
        );
      },
    },
    {
      field: "consultingField",
      minWidth: window.innerWidth < 991 ? 150 : 110,
      sortable: false,
    },
    {
      field: "MeetingStatus",
      minWidth: window.innerWidth < 991 ? 150 : 110,
      sortable: true,
      comparator: serverOnlySortComparator,
      cellRendererFramework: (params) => {
        const row = params?.data;
        const record = row?.data;
        if (!row || !record) return null;
        return (
          <div>
            <select
              className="form-control"
              name="statuses"
              onChange={(e) => handleChangestatus(e, record._id, row.MeetingStatus)}
              id="statuses"
              defaultValue={row.MeetingStatus}
            >
              {status.map((d, i) => (
                <option key={i} value={d.type}>
                  {d.type}
                </option>
              ))}
            </select>
          </div>
        );
      },
    },
    {
      field: "Admin comments",
      sortable: false,
      valueGetter: (params) => params?.data?.Comments,
      cellRendererFramework: (params) => {
        const row = params?.data;
        if (!row?.data) return <div className="commentColumn">Add Comment</div>;
        return (
          <div
            onClick={() => viewComment(row.data._id, row.Comments)}
            className="commentColumn"
          >
            {row.Comments
              ? `${row.Comments.slice(0, 10)}${row.Comments.length > 10 ? "......" : ""}`
              : "Add Comment"}
          </div>
        );
      },
    },
    {
      headerName: "View Document",
      sortable: false,
      filter: false,
      floatingFilter: false,
      width: window.innerWidth < 991 ? 120 : "unset",
      cellRendererFramework: (params) => {
        const record = params?.data?.data;
        if (!record) return null;
        return (
          <div>
            <Button
              onClick={() =>
                viewDocument(record._id, record.clientData?._id, record)
              }
            >
              View
            </Button>
          </div>
        );
      },
    },
    {
      headerName: "Action",
      sortable: false,
      filter: false,
      floatingFilter: false,
      width: 100,
      cellRendererFramework: (params) => {
        const record = params?.data?.data;
        if (!record) return null;
        return (
          <div>
            <Button
              onClick={() =>
                view(
                  record._id,
                  record.consultation?._id,
                  record,
                  record.offerDates
                )
              }
            >
              Update
            </Button>
          </div>
        );
      },
    },
    {
      field: "Offer Date",
      headerName: "Offer Date",
      sortable: false,
      filter: false,
      floatingFilter: false,
      width: 100,
      cellRendererFramework: (params) => {
        const row = params?.data;
        const record = row?.data;
        if (!row || !record) return null;
        return (
          <div>
            {record.requestedDates != 0 && !record.ASAP ? (
              <Button
                disabled={
                  row.MeetingStatus !== "Created" &&
                  row.MeetingStatus !== "DatesOffered"
                }
                onClick={() =>
                  openModal(
                    record._id,
                    record.requestedDates,
                    record.consultation?._id,
                    record.offerDates,
                    row.MeetingStatus,
                    record.requestedDates,
                    record.ASAP
                  )
                }
              >
                Offer
              </Button>
            ) : (
              <Button
                disabled={
                  row.MeetingStatus !== "Created" &&
                  row.MeetingStatus !== "DatesOffered"
                }
                onClick={() =>
                  asssonpossible(
                    record._id,
                    record.consultation?._id,
                    record.offerDates,
                    row.MeetingStatus,
                    record.requestedDates,
                    record.ASAP
                  )
                }
              >
                Offer
              </Button>
            )}
          </div>
        );
      },
    },
    {
      field: "Notification",
      filter: false,
      floatingFilter: false,
      editable: false,
      sortable: false,
      cellRendererFramework: (params) => {
        const record = params?.data?.data;
        if (!record) return null;
        return (
          <div>
            <input
              type="checkbox"
              className="noification_check"
              defaultChecked={record.isNotification ? true : false}
              onClick={(e) => UpdateDetails(e.target.checked, record._id)}
            />
          </div>
        );
      },
    },
    {
      field: "Report",
      filter: false,
      floatingFilter: false,
      editable: false,
      sortable: false,
      cellRendererFramework: (params) => {
        const record = params?.data?.data;
        if (!record) return null;
        return (
          <>
            {record.statuses === "Done" &&
            record.partnerId?.find(
              (element) => element === "64d326cd869f4f8664538775"
            ) ? (
              <Button
                onClick={() => handleGeneratePartnersXmlReport(record._id)}
              >
                XML Report
              </Button>
            ) : null}
          </>
        );
      },
    },
    {
      field: "Meeting Logs",
      filter: false,
      floatingFilter: false,
      editable: false,
      sortable: false,
      cellRendererFramework: (params) => {
        const record = params?.data?.data;
        if (!record) return null;
        return (
          <div>
            <Button onClick={() => meetinglog(record._id)}>View</Button>
          </div>
        );
      },
    },
    {
      field: "Request Description",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Age",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Email",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Client Id",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
    {
      field: "DOB",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
      valueFormatter: (params) => {
        return params.value ? moment(params.value).format("DD-MM-YYYY") : "";
      },
    },
    {
      field: "Gender",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Phone",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Marital Status",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
    {
      field: "Address",
      hide: true,
      sortable: false,
      filter: false,
      floatingFilter: false,
    },
  ];
}
